<mat-icon [class]="'s-' + size" [svgIcon]="icon" [matTooltip]="tooltipText"></mat-icon>
